export const CLOSE_ICON = 'https://www.materialui.co/materialIcons/navigation/cancel_black_192x192.png'

export const subcontract_rate_table = [
  { label: 'Subcontract ID', value: 0 },
  { label: 'Subcontract Name', value: 1 },
  { label: 'Start Date', value: 2 },
  { label: 'End Date', value: 3 },
  { label: 'Cost/MD', value: 4 },
  { label: 'Price/MD', value: 5 },
]



// WEBPACK FOOTER //
// ./src/components/subcontract-cost/constants.js